import type { ComponentType, ReactNode } from "react";
import { CheckCircle, Info, WarningCircle, type IconProps } from "@phosphor-icons/react";

/** A line that asks for attention above a list: a pending request, a refused write, a receipt. */
export function Callout({
  tone,
  icon,
  children,
  actions,
  role,
  testId
}: {
  tone?: "info" | "ok" | "warn" | "danger";
  /** A different mark than the tone's own, such as the lock on the client's Läsläge line. */
  icon?: ComponentType<IconProps>;
  children: ReactNode;
  actions?: ReactNode;
  role?: "status" | "alert";
  testId?: string;
}) {
  const Icon = icon ?? (tone === "ok" ? CheckCircle : tone === "warn" || tone === "danger" ? WarningCircle : Info);

  return (
    <div className={`callout${tone ? ` tone-${tone}` : ""}`} role={role} data-testid={testId}>
      <Icon size={18} aria-hidden="true" />
      <div>{children}</div>
      {actions}
    </div>
  );
}
